module.exports = __webpack_public_path__ + "img/images-01.87292507.png";